import React, { useState } from 'react'
import { getFormatedWeb3Address } from '../../utils/helpers';
import { toggleFollow } from '../../utils/services';
import { Link } from 'react-router-dom';

const Following = ({ profileFollowing, setProfileFollowing, setFollowStats }) => {
    const [loadingUserId, setLoadingUserId] = useState(null);

    const handleUnfollow = async (userId) => {
        setLoadingUserId(userId);
        try {
            const response = await toggleFollow(userId);
            if (response) {
                const unfollowedId = response?.data?.unfollow?._id;
                const updatedFollowing = profileFollowing.filter((item) => item?._id !== unfollowedId);
                setProfileFollowing(updatedFollowing);
                setFollowStats((prevStats) => ({
                    ...prevStats,
                    followingCount: prevStats.followingCount - 1
                }));
            }
        } catch (error) {
            console.error("Error unfollowing user:", error);
        } finally {
            setLoadingUserId(null);
        }
    };

    return (
        <>
            <div className="inner-tab-content inner-tab-content-fowin" style={{ display: "block" }}>
                <div className="fowin-parent">
                    {profileFollowing && profileFollowing.length > 0 ? (
                        profileFollowing?.map((item) => {
                            const userData = item?.following;
                            return (
                                <div className="single-user" key={item?._id}>
                                    <Link to={`/user-profile?id=${item?.following?._id}`} className="left-user">
                                        <div className="main-profile">
                                            <img
                                                src={userData?.profilePic || "/assets/youtube/1.png"}
                                                alt="profile"
                                                className='img-fluid'
                                            />
                                        </div>
                                        <div className="text">
                                            <h6>{userData?.name}</h6>
                                            <p>{getFormatedWeb3Address(userData?.walletAddress, true)}</p>
                                        </div>
                                    </Link>
                                    <button
                                        className='btn-unfollow'
                                        onClick={() => handleUnfollow(userData?._id)}
                                        disabled={loadingUserId === userData?._id}
                                    >
                                        {loadingUserId === userData?._id ? 'Unfollowing...' : 'Unfollow'}
                                    </button>
                                </div>
                            );
                        })
                    ) : (
                        <div className="no-results">
                            <p>No following found</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default Following
